import type { ReactElement } from 'react';
import { Link } from 'react-router-dom';

export const NotFoundPage = (): ReactElement => (
  <section className="space-y-4">
    <h1 data-route-heading tabIndex={-1} className="text-3xl font-semibold">
      Página no encontrada
    </h1>
    <p>La página que buscas no existe o ya no está disponible.</p>
    <Link className="underline" to="/">
      Volver al inicio
    </Link>
  </section>
);
